export default {"src":"/_next/static/media/telegram-3.8ba8be54.svg","height":97,"width":243,"blurWidth":0,"blurHeight":0};